import { render, staticRenderFns } from "./OrganizationAuditLogs.vue?vue&type=template&id=d1a83010"
import script from "./OrganizationAuditLogs.vue?vue&type=script&lang=js"
export * from "./OrganizationAuditLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports